import Axios from 'axios';
import { API } from 'core';
import { FEATURE_SETTINGS_DATA } from './types';

export const updateFeatureSettings = (value: boolean) => {
  const body = {
    is_resolution_reason_mandatory: value,
  };

  return Axios.patch<FEATURE_SETTINGS_DATA>(
    `${API.config.batman}/organizations/${API.config.organizationId}/feature-settings`,
    body,
  );
};

export const getFeatureSettings = async () => {
  const {
    data: { data },
  } = await Axios.get<{ data: FEATURE_SETTINGS_DATA }>(
    `${API.config.batman}/organizations/${API.config.organizationId}/feature-settings`,
  );
  return data.is_resolution_reason_mandatory;
};
